module.exports = __webpack_public_path__ + "assets/img/warrior-name-36c4cf98.png";